import { defineStore } from "pinia";
import type { FiltersState, ContentType, Tag, Topic } from "@/types";

export const useFiltersStore = defineStore("filters", {
  //persist: true,
  state: (): FiltersState => ({
    tags: [],
    topics: [],
    contentTypes: []
  }),
  actions: {
    setTag(id: Tag | null = null) {
      if (id === null) {
        this.tags = [];
      } else if (this.tags.includes(id)) {
        this.tags.splice(this.tags.indexOf(id), 1);
      } else {
        this.tags.push(id);
      }
    },
    setTopic(id: Topic | null = null) {
      if (id === null) {
        this.topics = [];
      } else if (this.topics.includes(id)) {
        this.topics.splice(this.topics.indexOf(id), 1);
      } else {
        this.topics.push(id);
      }
    },
    setContentType(id: ContentType | null = null) {
      if (id === null) {
        this.contentTypes = [];
      } else if (this.contentTypes.includes(id)) {
        this.contentTypes.splice(this.contentTypes.indexOf(id), 1);
      } else {
        this.contentTypes.push(id);
      }
    }
  },
  getters: {
    getTags: state => state.tags,
    getTopics: state => state.topics,
    getContentTypes: state => state.contentTypes
  }
});
